import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from './../modules/adoption/middleware'
import DatePicker from '../components/DatePicker'

const mapStateToProps = ({ adoption, auth }) => ({
  date: adoption.adoptionDueDate,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    changeAdoptionDueDate: (date) => AdoptionMiddleware.changeAdoptionDueDate(date)
  }, dispatch)
}

class DatePickerContainer extends Component {
  onDateChange = (moment) => {
    const { changeAdoptionDueDate } = this.props
    const date = moment.format('YYYY-MM-DD')
    changeAdoptionDueDate({ date })
  }
  isDirector () {
    if (['director', 'fractal_operator'].includes(this.props.role)) return true
    return false
  }
  render () {
    const { date } = this.props
    return (
      <DatePicker
        onDateChange={this.onDateChange}
        date={date}
        disabled={!this.isDirector()}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerContainer)



// WEBPACK FOOTER //
// ./src/containers/DatePickerContainer.js